// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Section_elSection__3SKz5 {\n  margin-bottom: 16px; }\n\n.Section_cardSection__2nUfJ {\n  margin-top: 36px;\n  margin-bottom: 18px; }\n\n.Section_elForm__DqUYa .Section_securityField1__2nk0_ {\n  max-width: calc(25% - 30px) !important;\n  min-width: calc(25% - 30px) !important; }\n", ""]);
// Exports
exports.locals = {
	"elSection": "Section_elSection__3SKz5",
	"cardSection": "Section_cardSection__2nUfJ",
	"elForm": "Section_elForm__DqUYa",
	"securityField1": "Section_securityField1__2nk0_"
};
module.exports = exports;
